class PolymerAssetType {

}

PolymerAssetType.Video = { id: "video", fileTypes: ['mp4', 'mov'] }
PolymerAssetType.Color = { id: "color", fileTypes: ['rgb'] }
PolymerAssetType.Image = { id: "image", fileTypes: ['jpg', 'jpeg', 'png', 'gif'] }
PolymerAssetType.Model = { id: "model", fileTypes: ['glb', 'glbz'] }

export default PolymerAssetType